<template>
	<div class="spinner-container">
		<i class="fas fa-circle-notch fa-spin"></i>
	</div>
</template>

<script>
	export default {
		name: 'LoaderComponent',
		props: [],
		data() {
			return {};
		},
		computed: {},
		created() {},
		mounted() {},
		methods: {},
		components: {},
	};
</script>

<style></style>
